import { useEffect } from 'react';
import { useWidgetStore } from '../store';
import WidgetManager from '../lib/WidgetManager';

export const useWidgetCoordination = (widgetId: string) => {
  const isWidgetActive = useWidgetStore(state => state.isWidgetActive);
  const isWidgetDisabled = useWidgetStore(state => state.isWidgetDisabled);
  const setIsWidgetActive = useWidgetStore(state => state.setWidgetActive);
  const setIsWidgetDisabled = useWidgetStore(state => state.setIsWidgetDisabled);
  const setButtonState = useWidgetStore(state => state.setButtonState);

  const widgetManager = WidgetManager.getInstance();

  useEffect(() => {
    const handleWidgetActivated = ({ widgetId: activeWidgetId }: { widgetId: string }) => {
      const isDisabled = activeWidgetId !== widgetId;
      setIsWidgetDisabled(isDisabled);
      if (isDisabled) {
        setIsWidgetActive(false);
        setButtonState('disabled');
      } else {
        setIsWidgetActive(true);
      }
    };

    const handleManagerWidgetDeactivated = () => {
      setIsWidgetDisabled(false);
      setIsWidgetActive(false);
      if (useWidgetStore.getState().buttonState === 'disabled') {
        setButtonState('idle');
      }
    };

    widgetManager.on('widget-activated', handleWidgetActivated);
    widgetManager.on('widget-deactivated', handleManagerWidgetDeactivated);

    // Register this widget and auto-activate if no other widget is currently active
    widgetManager.registerWidget({ id: widgetId, agentId: widgetId, isActive: false, isExpanded: false });
    if (!widgetManager.getActiveWidgetId()) {
      widgetManager.activateWidget(widgetId);
    }

    return () => {
      widgetManager.off('widget-activated', handleWidgetActivated);
      widgetManager.off('widget-deactivated', handleManagerWidgetDeactivated);
      widgetManager.unregisterWidget(widgetId);
    };
  }, [widgetId, setIsWidgetActive, setIsWidgetDisabled, setButtonState, widgetManager]);

  return {
    isWidgetActive,
    isWidgetDisabled,
  };
};
